module.exports = __webpack_public_path__ + "img/b_Anevil_left.5a5cd982.jpeg";